const proposalDocumentTypes = Object.freeze({
  AmendmentDocument: 19,
});

export default proposalDocumentTypes;
